import { render, staticRenderFns } from "./mxXhmDetail.vue?vue&type=template&id=a250c32a&"
import script from "./mxXhmDetail.vue?vue&type=script&lang=js&"
export * from "./mxXhmDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports